import {
    BEGIN_AJAX_CALL,
    END_AJAX_CALL,
    GET_STRATEGY_CREATIVE_DETAILS,
    GET_CREATIVE_VALIDATION_DETAILS,
    GET_CREATIVE_TRACKER_DETAILS
} from '../../constants/actionType';
import { 
    postCreativeApi, 
    postCampaignApi, 
    postGlobalCreativeListApi,
    getCreativeNameListApi
 } from "../../api/creative";

export const postGlobalCreativeAction = ({ tenantId, authToken, userId, params, payload }) => async dispatch => {
    let postCreativeData = {};
    try {
        dispatch({
            type: BEGIN_AJAX_CALL,
            showSpinner: true,
        });
        postCreativeData = await postCreativeApi({ tenantId, authToken, userId, params, payload });
        return postCreativeData;
    } catch (err) {
    } finally {
        dispatch({
            type: END_AJAX_CALL,
            showSpinner: false,
        });
    }
};

export const postGlobalCreativeActionWithoutLoader = ({ tenantId, authToken, userId, params, payload }) => async dispatch => {
    let postCreativeData = {};
    try {
        // dispatch({
        //     type: BEGIN_AJAX_CALL,
        //     showSpinner: true,
        // });
        postCreativeData = await postCreativeApi({ tenantId, authToken, userId, params, payload });
        return postCreativeData;
    } catch (err) {
    } finally {
        // dispatch({
        //     type: END_AJAX_CALL,
        //     showSpinner: false,
        // });
    }
};

export const getCreativeNameListAction = ({ tenantId, authToken, userId, params = {}}) => async dispatch => {
    let globalCreativeNameList = {};
    try {
        // dispatch({
        //     type: BEGIN_AJAX_CALL,
        //     showSpinner: true,
        // });

        globalCreativeNameList = await getCreativeNameListApi({ tenantId, authToken, userId, params });
        return globalCreativeNameList;
    } catch (err) {
    } finally {
        // dispatch({
        //     type: END_AJAX_CALL,
        //     showSpinner: false,
        // });
    }
};

export const postCampaignDataAction = ({ tenantId, authToken, userId, params, payload }) => async dispatch => {
    let postCampaignData = {};
    try {
        dispatch({
            type: BEGIN_AJAX_CALL,
            showSpinner: true,
        });
        postCampaignData = await postCampaignApi({ tenantId, authToken, userId, params, payload });
        return postCampaignData;
    } catch (err) {
    } finally {
        dispatch({
            type: END_AJAX_CALL,
            showSpinner: false,
        });
    }
};

export const postGlobalCreativeListAction = ({ tenantId, authToken, userId, params = {}, payload = {} }) => async dispatch => {
    let globalCreativeList = {};
    try {
        dispatch({
            type: BEGIN_AJAX_CALL,
            showSpinner: true,
        });

        globalCreativeList = await postGlobalCreativeListApi({ tenantId, authToken, userId, params, payload });
        return globalCreativeList;
    } catch (err) {
    } finally {
        dispatch({
            type: END_AJAX_CALL,
            showSpinner: false,
        });
    }
};

export const strategyCreativeDataAction = ({ data }) => async dispatch => {
    try {
        dispatch({
            type: GET_STRATEGY_CREATIVE_DETAILS,
            strategyCreativeData: data,
        });
    } catch (err) {
    } finally {

    }
};

export const creativeValidationDataAction = ({ data }) => async dispatch => {
    try {
        dispatch({
            type: GET_CREATIVE_VALIDATION_DETAILS,
            creativeValidationData: data,
        });
    } catch (err) {
    } finally {

    }
};

export const creativeTrackerDataAction = ({ data }) => async dispatch => {
    try {
        dispatch({
            type: GET_CREATIVE_TRACKER_DETAILS,
            creativeTrackerData: data,
        });
    } catch (err) {
    } finally {

    }
};